export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  DISMISSED_PLATFORM_BANNERS: 'dismissedPlatformBanners',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  DISMISSED_EXPIRATION_BANNER: 'dismissedExpirationBanner',
  // v2: chave renomeada para descartar larguras salvas pela logica antiga
  // (containerWidth / 2), que ficava desproporcional em telas menores/maiores.
  CONTACT_DETAIL_SIDEBAR_WIDTH: 'contactDetailSidebarWidthV2',
  COMPANY_DETAIL_SIDEBAR_WIDTH: 'companyDetailSidebarWidthV2',
  DEAL_DETAIL_SIDEBAR_WIDTH: 'dealDetailSidebarWidthV2',
  MEU_ESPACO_EVOLUTION_VISIBLE: 'meuEspacoEvolutionVisible',
};
